import React, { useContext, useEffect, useState } from "react";
import "../../../leaveNotes/leaveNotePopup.css";
import "../../organization/department/DepartmentPopup.css";
import CloseIcon from "../../../../images/CloseIcon.svg";
import AuthContext from "../../../context/auth-context";
// import { Fetchdata } from "../../hooks/getData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Fetchdata } from "../../../hooks/getData";
import UpperbarContext from "../../../context/upperbar-context";
import Toast from "../../../Toast";
import Calendar from "@sbmdkl/nepali-datepicker-reactjs";
import { GetEnglishDate } from "../../../hooks/dateConvertor";
import $ from "jquery";
import { nepaliToEnglishNumber } from "nepali-number";

export default function HolidayPopup({
  setHolidayPopup,
  reload,
  setReload,
  holidayFormValue,
  setHolidayFormValue,
  holidayFormError,
  setHolidayFormError,
  holiList,
  DFlag,
  holidayPopup,
  re,
}) {
  const { User } = useContext(AuthContext);
  const { mode, appURL, dateMode } = useContext(UpperbarContext);

  const closePopUp = (e) => {
    setHolidayPopup(false);
    setHolidayFormError({});
    $(".addHolidayPopBg").fadeOut(500);
    $(".addHolidayPop").slideUp(500);
    setIsSubmit(false);
  };

  useEffect(() => {
    if (holidayPopup) {
      $(".addHolidayPopBg").fadeIn(500);
      $(".addHolidayPop").slideDown(500);
    }
  }, [holidayPopup]);

  const handleChange = (e) => {
    const target = e.target;
    const name = target.name;
    const value = target.type == "checkbox" ? target.checked : target.value;
    setHolidayFormValue({ ...holidayFormValue, [name]: value });
  };

  const handleEventDate = ({ bsDate }) => {
    let name = "eventDate";
    setHolidayFormValue({ ...holidayFormValue, [name]: bsDate });
  };

  const [isSubmit, setIsSubmit] = useState(false);

  const validate = (values) => {
    const errors = {};
    if (!values.event) {
      errors.event = mode === "en" ? "Required" : "आवश्यक छ";
    }
    if (!values.eventDate) {
      errors.eventDate = mode === "en" ? "Required" : "आवश्यक छ";
    }
    if (!values.option) {
      errors.option = mode === "en" ? "Required" : "आवश्यक छ";
    }

    return errors;
  };

  const formSubmit = (e) => {
    e.preventDefault();
    setHolidayFormError(validate(holidayFormValue));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (Object.keys(holidayFormError).length === 0 && isSubmit) {
      const dataForm = {
        AuthCode: User.AuthCode,
        ComID: User.ComID,
        UserID: User?.UserID,
        Flag: "i",
        Title: holidayFormValue.event,
        EvType: holidayFormValue.option,
        EnglishDate:
        dateMode === "np" && holidayFormValue.eventDate
            ? GetEnglishDate(holidayFormValue.eventDate)
            : holidayFormValue.eventDate,
        BranchID: User.BranchID,
        FiscalID: User.FiscalID,
        FetchURL: `${appURL}api/admin/event`,
        Type: "POST",
      };

      Fetchdata(dataForm).then(function (result) {
        if (result.StatusCode === 200) {
          setHolidayPopup(false);
          holiList();
          $(".addHolidayPopBg").fadeOut(500);
          $(".addHolidayPop").slideUp(500);
          toast.success(result.Message, {
            style: {
              color: "green",
              fontSize: "13px",
            },
            theme: "light",
          });
        } else {
          toast.error("Error: " + result.Message, {
            style: {
              color: "red",
              fontSize: "13px",
            },
            theme: "light",
          });
        }
      });

      setIsSubmit(false);
    }
  }, [holidayFormError]);

  return (
    <>
      {/* <Toast /> */}
      <div className="container newpopup-bg addHolidayPopBg">
        <div className="newpopup addHolidayPop">
          <div className="newpopup-head ps-0 pe-0">
            <div className="popUpTitle">{mode === "en" ? "Event" : "घटना"}</div>
            <div className="popUpClose">
              <img
                className="popUpCloseIcon"
                src={CloseIcon}
                alt="CloseIcon"
                onClick={closePopUp}
              />
            </div>
          </div>
          <div className="newpopup-body ps-3 pe-3">
            <div className="form-in-padding">
              <div className="row text-start mt-2 ">
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="row text-start ">
                    <div className="form-group mt-0">
                      <label htmlFor="event" style={{ fontSize: "12px" }}>
                        {mode === "en" ? "Title" : "शीर्षक"}
                        <sup style={{ color: "red" }}>*</sup>
                      </label>
                      <input
                        id="event"
                        style={{ fontSize: "13px" }}
                        type="text"
                        className="form-control form-control-sm "
                        name="event"
                        value={holidayFormValue.event}
                        onChange={handleChange}
                        placeholder={mode === "en" ? "Title" : "शीर्षक"}
                      />
                      {holidayFormError.event && (
                        <p className="errormsg">{holidayFormError.event}</p>
                      )}
                    </div>
                  </div>

                  <div className="row text-start ">
                    <div className="form-group">
                      <label htmlFor="eventDate" style={{ fontSize: "12px" }}>
                        {mode === "en" ? "Event Date" : "घटना मिति"}{" "}
                        <sup style={{ color: "red" }}>*</sup>
                      </label>
                      {/* <input
                      id="eventDate"
                      style={{ fontSize: "13px" }}
                      type="date"
                      className="form-control form-control-sm "
                      name="eventDate"
                      value={holidayFormValue.eventDate}
                      onChange={handleChange}
                    /> */}
                      {dateMode === "np" ? (
                        <Calendar
                          id="eventDate"
                          className="form-control form-control-sm pt-0 pb-0 "
                          dateFormat="YYYY/MM/DD"
                          // defaultDate="2010/01/01"
                          theme="default"
                          language="en"
                          // language={mode === "en" ? "en" : "np"}
                          value={holidayFormValue.eventDate}
                          onChange={handleEventDate}
                          name="eventDate"
                          key={re}
                          // hideDefaultValue={true}
                          // placeholder={"Select Follow Date"}
                        />
                      ) : (
                        <input
                          type="date"
                          value={holidayFormValue.eventDate}
                          placeholder="Select a Date"
                          className="form-control form-control-sm "
                          name="eventDate"
                          onChange={handleChange}
                          id="eventDate"
                        />
                      )}
                      {holidayFormError.eventDate && (
                        <p className="errormsg">{holidayFormError.eventDate}</p>
                      )}
                    </div>
                  </div>

                  <div className="row text-start">
                    <div className="form-group">
                      <label
                        htmlFor="subDepartment"
                        style={{ fontSize: "12px" }}
                      >
                        {mode === "en"
                          ? "Select Option"
                          : "विकल्प चयन गर्नुहोस्"}
                        <sup style={{ color: "red" }}>*</sup>
                      </label>
                      <select
                        class="form-select form-select-sm"
                        aria-label="Default select example"
                        name="option"
                        value={holidayFormValue.option}
                        onChange={handleChange}
                      >
                        <option disabled value="" selected>
                          {mode === "en"
                            ? "Select Option"
                            : "विकल्प चयन गर्नुहोस्"}
                        </option>

                        <option value="E">Event</option>
                        <option value="H">Holiday</option>
                      </select>
                      {holidayFormError.option && (
                        <p className="errormsg">{holidayFormError.option}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="new-footer">
            <div className="row  mt-1 mb-1">
              <div>
                <button
                  type="button"
                  class="btn btn-sm me-2"
                  style={{ background: "var(--button-color)", color: "white" }}
                  onClick={formSubmit}
                >
                  {mode === "en" ? "Submit" : "बुझाउनुहोस्"}
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-danger me-3"
                  style={{ color: "white" }}
                  onClick={closePopUp}
                >
                  {mode === "en" ? "Cancel" : "बन्द गर्नुहोस्"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
